module.exports = __webpack_public_path__ + "static/media/back.02ff89e7.svg";